<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @deleted="alertDeleted"
            @cancel="item = false" @error="alertError"></view-item>

        <list-items v-else title="Activity Categories" :items="categories" @show-item="showItem" ref="table">
            <b-button id="add-category-btn" block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'activityCategories',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        // this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('activity_category') },
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },


    methods: {
        async doSearch() {
            await this.$store.dispatch('orderCategory/fetchAll')
        },

        showItem(id) {
            const item = this.categories.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, name, message) {
            this.genericToast(this.componentName, this.$translate(`${action}d`), 'success', `"${name}" ${message}`)
            this.item = null
            this.doSearch()
        },

        alertDeleted(name) {
            this.genericToast(this.componentName, this.$translate('deleted'), 'success', `"${name}" ${this.$translate('delete_alert')}`)
            this.item = null
            this.doSearch()
        },

        alertError(error) {
            this.doToast( this.$translate('error'), `${error}`, 'danger')
        }
    },
}
</script>
<style></style>
